import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import SweetAlert from "react-bootstrap-sweetalert";
import { API_URL } from "../../../utility";
import axios from "axios";
import logo from "../../../asserts/logo.png";
import ReactToPrint from 'react-to-print';
import Loader from "../../common/Loader";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


function currentDate() {
    const date = new Date();
    const formatedDate = date.toISOString().split('T')[0];
    return formatedDate;
}

const TransferOption = ({ amount, setAmount }) => {
    const imgBase32 = "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";
    const [showPassword, setShowPassword] = useState(false);
    const [isDownloaded, setIsDownloaded] = useState(0);

    const [option, setOption] = useState(null);

    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    const [data, setData] = useState(null);

    const [show, setShow] = useState(false);
    const [show2, setShow2] = useState(false);
    const [show3, setShow3] = useState(false);
    const [show4, setShow4] = useState(false);
    const [show5, setShow5] = useState(false);
    const [show6, setShow6] = useState(false);

    const imageUrl = `data:image/png;base64,${imgBase32}`;

    const handleShow = () => setShow(true);

    const showPopUpFunc = () => {
        // if(option !== "Bank Transfer" && option !== null){
        if (option !== null) {
            setLoading(true);
            const token = localStorage.getItem("user_token");
            axios.post(`${API_URL}/user/funds/create-request`, { request_type: option, order_id: null, funding_amount: amount }, { headers: { 'Authorization': `Bearer ${token}` } }).then((res) => {
                console.log("Create Request res : ", res);
                if (res?.data?.data?.error) {
                    toast.error(res?.data?.data?.error);
                    return 0;
                } else {
                    setData(res?.data?.data);
                    toast.success(res?.data?.data?.textEN);

                    console.log("option : ", option);
                    if (option === "QR Code") {
                        setShow(true);
                    } else if (option === "Credit Card") {
                        setShow2(true);
                    }
                    // else if(option === "Bank Transfer"){
                    //     setShow3(true);
                    // }
                }
                setLoading(false);
            }).catch((err) => {
                toast.error(err?.response?.data?.error?.funding_amount ? err?.response?.data?.error?.funding_amount[0] : err?.response?.data?.error?.request_type ? err?.response?.data?.error?.request_type[0] : err?.response?.data?.data?.error)
                setLoading(false);
                console.log("Create Request error : ", err);
            })
        }
        if (option === "Bank Transfer") {
            setShow3(true);
        }


    }
    const handleClose = () => {
        setShow(false);
    };

    const handleClose2 = () => {
        setShow2(false);
    };
    const handleClose3 = () => {
        setShow3(false);
    };


    const componentRef = useRef();


    // State to store remaining time
    const [startTime, setStartTime] = useState(0);
    const [endTime, setEndTime] = useState(0);
    const [timeLeft, setTimeLeft] = useState(0);

    useEffect(() => {
        let interval;
        if (data) {
            console.log("Time useEffect runing : ", show, data);
            const currentTime = Date.now();
            setStartTime(currentTime);
            //  setEndTime(currentTime + 10 * 60 * 1000); // Set end time 10 minutes from now
            setEndTime(currentTime + (data?.timeOut * 1000)); // Set end time 10 minutes from now
            //  console.log("setting time : ", startTime);
            //  console.log("setting time : ", endTime);
            interval = setInterval(() => {
                //    const remainingTime = (currentTime + 10 * 60 * 1000) - Date.now();
                const remainingTime = (currentTime + (data?.timeOut * 1000)) - Date.now();
                //    console.log("remainingTime : ", remainingTime);
                if (remainingTime <= 0) {
                    console.log("if true");
                    setShow(false); // Close popup after 10 minutes
                    setAmount(null);
                    navigate('/fund-requests');
                    clearInterval(interval);
                } else {
                    setTimeLeft(remainingTime);
                }
            }, 1000);
        }

        return () => clearInterval(interval);
    }, [data]);

    const formatTime = (milliseconds) => {
        const totalSeconds = Math.floor(milliseconds / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };


    useEffect(() => {
        const token = localStorage.getItem("user_token");
        // console.log("token : ", token);
        axios.get(`${API_URL}/user/profile`, { headers: { 'Authorization': `Bearer ${token}` } }).then((res) => {
            console.log("View User res : ", res);
            setUser(res?.data);
        }).catch((err) => {
            console.log("View User error : ", err);
        })
    }, [])


    // Function to handle the download button click
    const handleDownload = () => {
        if (isDownloaded === 0) {

            const date = new Date();
            // const imageUrl = `data:image/png;base64,${imgBase32}`;
            const imageUrl = `data:image/png;base64,${data?.content}`;

            // Creating a link element
            const link = document.createElement('a');
            link.href = imageUrl;
            link.download = `payment_qr_code_${date}.png`;

            // Triggering the download
            document.body.appendChild(link);
            link.click();

            // Removing the link element from the DOM
            document.body.removeChild(link);
            setIsDownloaded(1);
        }
    };

    const sendRequest = () => {
        // const token = localStorage.getItem("user_token");

        // console.log("token : ", token);
        // axios.post(`${API_URL}/user/funds/fund-request`, {fund_amount: amount,  order_id: data?.orderID, transfer_type: option}, {headers: {'Authorization': `Bearer ${token}`}}).then((res) => {
        //     console.log("Fund request add res : ", res);
        //     toast.success("Fund request created successfully");
        //     setAmount(null);
        //     navigate('/fund-requests')
        // }).catch((err) => {
        //     console.log("Fund request add error : ", err);
        // })
        navigate('/fund-requests')
        setAmount(null);
    }

    return (
        <div className="staff-detail-page edit-profile">
            <ToastContainer />
            <div style={{ display: 'none' }}>
                <ComponentToPrint amount={amount} ref={componentRef} />
            </div>

            <h1 className="staffRegNumber">Create New Quotation</h1>
            <h6 className="breadCrumbs mt-4 pb-3">
                <span className="pointer" onClick={() => navigate('/fund-requests')}>Top Up List</span>
                <span className="greater-than"> &#62; </span>
                <span className="pointer" onClick={() => navigate(`/fund-requests/add`)}>Create New Quotation</span>
                <span className="greater-than"> &#62; </span>
                <span className="viewVCardText">Transfer</span>
            </h6>

            <h3 className="staffdetail-sub-heading mt-4">Transfer Option</h3>

            <div className="d-flex pt-2">
                <div className="div1 w-75 ms-3">
                    <div className="displayBlockText d-flex align-items-center">
                        <input type="radio" onChange={(e) => setOption(e.target.value)} value="QR Code" name="transfer" id="qr_code" />
                        <p className="d-flex align-items-center mb-0 ms-4"><label className="pointer" for="qr_code">QR Code</label></p>
                    </div>
                    <div className="displayBlockText d-flex align-items-center">
                        <input type="radio" onChange={(e) => setOption(e.target.value)} value="Credit Card" name="transfer" id="card" />
                        <p className="d-flex align-items-center mb-0 ms-4"><label className="pointer" for="card">Credit Card</label></p>
                    </div>
                    <div className="displayBlockText d-flex align-items-center">
                        <input type="radio" onChange={(e) => setOption(e.target.value)} value="Bank Transfer" name="transfer" id="bank" />
                        <p className="d-flex align-items-center mb-0 ms-4"><label className="pointer" for="bank">Bank Transfer</label></p>
                    </div>
                </div>
            </div>

            <div className="d-flex mt-4 mb-5">
                <button className="pointerButton px-5" onClick={showPopUpFunc}>Transfer</button>
                <button className="secondaryPointerButton ms-4 px-5" onClick={() => navigate('/fund-requests/add')}>Back</button>
            </div>
            {show4 && (
                <SweetAlert
                    warning
                    showCancel
                    confirmBtnText="Yes Sure!"
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle="secondary"
                    title="Are you sure?"
                    onConfirm={() => { setShow4(false); setShow(false); setAmount(null); navigate('/fund-requests') }}
                    onCancel={() => { setShow4(false); }}
                    focusCancelBtn
                >
                    You want cancel the transaction?
                </SweetAlert>
            )}
            {show6 && (
                <SweetAlert
                    warning
                    showCancel
                    confirmBtnText="Yes Sure!"
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle="secondary"
                    title="Are you sure?"
                    onConfirm={() => { setShow6(false); setAmount(null); setShow2(false); navigate('/fund-requests') }}
                    onCancel={() => { setShow6(false); }}
                    focusCancelBtn
                >
                    You want cancel the transaction?
                </SweetAlert>
            )}
            {show5 && (
                <SweetAlert
                    warning
                    showCancel
                    confirmBtnText={isDownloaded === 0 ? "Yes Sure!" : "Yes Sure!"}
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle="secondary"
                    title={isDownloaded === 0 ? "Are you sure?" : "Warning"}
                    onConfirm={() => { setShow5(false); setShow(false); sendRequest(); }}
                    onCancel={() => { setShow5(false); }}
                    focusCancelBtn
                >
                    {isDownloaded === 0 ? `You have downloaded the qr code?` : `Your qr code will expire in 10 mints.`}
                </SweetAlert>
            )}
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                {/* <Modal.Header closeButton> */}
                {loading ? (
                    <Loader />
                ) : (
                    <>
                        <Modal.Header>
                            <div className="w-100 text-center">
                                <h2 className="mb-0 text-center">Qr Code</h2>
                            </div>
                        </Modal.Header>
                        <Modal.Body>
                            <div>
                                <div className="w-100 text-center">
                                    <img src={`data:image/png;base64,${data?.content}`} alt="Payment QR Code" />
                                    {/* <p>{`data:image/png;base64,${data?.content}`}</p> */}
                                    <p>Amount: <b>{Number(data?.amount).toLocaleString()}</b> </p>
                                    {timeLeft > 0 ? (
                                        <>
                                            <h3>Time Left: {formatTime(timeLeft)}</h3>
                                        </>
                                    ) : (
                                        <>
                                            {/* <p>Time Elapsed: {formatTime(Date.now() - startTime)}</p> */}
                                        </>
                                    )}
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="w-100 text-center">
                                <button className="btn-2" onClick={() => setShow4(true)}>Cancel</button>
                                <button className="btn-3 mx-2" onClick={handleDownload} >Download</button>
                                <button className="btn-2 bg-success text-white" onClick={() => setShow5(true)}>Done</button>
                            </div>
                            {/* <Button variant="secondary" onClick={handleClose}>
                            Close
                        </Button>
                        <Button variant="primary">Understood</Button> */}
                        </Modal.Footer>
                    </>
                )}
            </Modal>
            {/* qr code model ends  */}


            {/* credit card model starts  */}
            <Modal
                show={show2}
                onHide={handleClose2}
                backdrop="static"
                keyboard={false}
            >
                {loading ? (
                    <Loader />
                ) : (
                    <>
                        {/* <Modal.Header closeButton> */}
                        <Modal.Header>
                            <div className="w-100 d-flex justify-content-between text-center">
                                <div>
                                    <h2 className="mb-0 text-center">Credit Card</h2>
                                </div>
                                <div>
                                    {timeLeft > 0 ? (
                                        <>
                                            <h3 className="mb-0">Time Left: {formatTime(timeLeft)}</h3>
                                        </>
                                    ) : (
                                        <>
                                            {/* <p>Time Elapsed: {formatTime(Date.now() - startTime)}</p> */}
                                        </>
                                    )}
                                </div>
                            </div>
                        </Modal.Header>
                        <Modal.Body>
                            <div>
                                <div className="w-100 text-center">
                                    {/* <iframe src="https://youtube.com" height="200" width="300" title="Iframe Example"></iframe> */}
                                    <iframe
                                        title="Web Page Display"
                                        // src="https://volta-webapp.pea.co.th/payment/cardformlite.php?id=33898&lang=TH"
                                        src={data?.content}
                                        width="100%"
                                        height="500px"
                                        frameBorder="0"
                                    ></iframe>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="w-100 text-center">
                                <button className="btn-2 me-1" onClick={() => setShow4(true)}>Cancel</button>
                                {/* <button className="btn-3 mx-2" onClick={handleDownload} >Download</button> */}
                                <button className="btn-2 ms-1 bg-success text-white" onClick={() => { setShow2(false); sendRequest(); }}>Done</button>
                            </div>
                            {/* <Button variant="secondary" onClick={handleClose}>
                            Close
                        </Button>
                        <Button variant="primary">Understood</Button> */}
                        </Modal.Footer>
                    </>
                )}
            </Modal>
            {/* credit card model ends  */}


            {/* bank transfer model starts  */}
            <Modal
                show={show3}
                onHide={handleClose3}
                backdrop="static"
                keyboard={false}
                size="lg"
            >
                {/* <Modal.Header closeButton> */}
                <Modal.Header>
                    <div className="w-100 text-center">
                        <h2 className="mb-0 text-center">Bank Transfer</h2>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <div>
                            <div className="d-flex w-100 invoice-header px-4 py-3 pt-4">
                                <div className="w-50">
                                    <img src={logo} height={"125px"} alt="logo" />
                                </div>
                                <div className="w-50">
                                    <div className="text-end">
                                        <h2 className="mb-1 clr-303778">Provincial Electricity Authority</h2>
                                        <p className="mb-1">200 Ngam Wong Wan Rd., Lat yao, Chatuchak Bangkok 10900</p>
                                        <p className="mb-1">(Tax ID No.) 09940001655</p>
                                    </div>
                                </div>
                            </div>
                            <div className="w-100 text-center">
                                <h1 className="clr-303778 mb-1">Quatation</h1>
                            </div>
                            <div className="d-flex w-100 px-4 py-3">
                                <div className="w-50">
                                    <div>
                                        <h2 className="mb-1">{user?.user?.name}</h2>
                                        <p className="mb-1">{user?.user?.address}</p>
                                        <p className="mb-1">{user?.user?.email}</p>
                                    </div>
                                </div>
                                <div className="w-50">
                                    <div className="text-end">
                                        <p className="mb-1 mt-2">{currentDate()}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="w-100 px-4">
                                <table className="pdf-table1">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Description</th>
                                            <th>Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="bg-303778 w-60px">01</td>
                                            <td>
                                                <h6 className="mb-1">Fund Request</h6>
                                                {/* <p className="mb-0">Fund request for staff</p> */}
                                            </td>
                                            <td className="bg-303778 w-100px">${amount}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="d-flex w-100 px-4 py-3">
                                <div className="w-65">
                                    {/* <h3 className="pt-4">Thank You</h3> */}
                                </div>
                                <div className="w-35">
                                    <div>
                                        <table className="pdf-table2">
                                            <thead>
                                                <tr className="bb-rgb-237">
                                                    <th>SUBTOTAL</th>
                                                    <th>${amount - (amount * 0.07)}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr className="bb-303778">
                                                    <th className="clr-303778">TAX 7%</th>
                                                    <th className="clr-303778">${(amount * 0.07)?.toFixed(2)}</th>
                                                </tr>
                                                <tr>
                                                    <th>GRAND TOTAL</th>
                                                    <th>${(parseFloat(amount))?.toFixed(2)}</th>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="w-100 text-center">
                        <button className="btn-2 me-1" onClick={() => setShow4(true)}>Cancel</button>
                        <ReactToPrint
                            trigger={() => (
                                <button className="btn-3 mx-2" onClick={handleDownload} >Print</button>
                            )}
                            content={() => componentRef.current}
                        />
                        {/* <button className="btn-2 px-4 ms-2">
                                Print
                                <svg className="ms-2" xmlns="http://www.w3.org/2000/svg" width="17.456" height="17.456" viewBox="12542.733 -17629.979 17.456 17.456"><g data-name="CompositeLayer"><path d="M12546.224-17619.504h10.474v6.983h-10.474v-6.983Z" stroke-linejoin="round" stroke-linecap="round" stroke-width="2.5" stroke="#303778" fill="transparent" data-name="Path 37"/><path d="M12546.224-17616.014h-1.746a1.746 1.746 0 0 1-1.745-1.745v-4.364c0-.965.781-1.746 1.745-1.746h13.966c.964 0 1.746.781 1.746 1.746v4.364c0 .964-.782 1.745-1.746 1.745h-1.746" stroke-linejoin="round" stroke-linecap="round" stroke-width="2.5" stroke="#303778" fill="transparent" data-name="Path 36"/><path d="M12546.224-17623.869v-6.11h10.474v6.11" stroke-linejoin="round" stroke-linecap="round" stroke-width="2.5" stroke="#303778" fill="transparent" data-name="Path 35"/></g></svg>
                            </button> */}
                        <button className="btn-2 ms-1 bg-success text-white" onClick={() => { setShow2(false); sendRequest(); }}>Done</button>
                    </div>
                    {/* <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                <Button variant="primary">Understood</Button> */}
                </Modal.Footer>
            </Modal>
            {/* credit card model ends  */}
        </div>
    )
}

export default TransferOption;


const ComponentToPrint = React.forwardRef(({ amount }, ref) => {
    const [user, setUser] = useState(null);

    useEffect(() => {
        const token = localStorage.getItem("user_token");
        // console.log("token : ", token);
        axios.get(`${API_URL}/user/profile`, { headers: { 'Authorization': `Bearer ${token}` } }).then((res) => {
            console.log("View User res : ", res);
            setUser(res?.data);
        }).catch((err) => {
            console.log("View User error : ", err);
        })
    }, [])

    return (
        <div className="w-100" ref={ref}>
            <div className="d-flex w-100 invoice-header px-4 py-3 pt-4">
                <div className="w-50">
                    <img src={logo} height={"125px"} alt="logo" />
                </div>
                <div className="w-50">
                    <div className="text-end">
                        <h1 className="mb-1 clr-303778">PEA HOME</h1>
                        <p className="mb-1">Trigon Group (Thailand) CO., LTD.</p>
                        <p className="mb-1">(123) 456 -829</p>
                        <p className="mb-1">company@example.com</p>
                    </div>
                </div>
            </div>
            <div className="w-100 text-center">
                <h1 className="clr-303778 mb-1">Quatation</h1>
            </div>
            <div className="d-flex w-100 px-4 py-3">
                <div className="w-50">
                    <div>
                        <h2 className="mb-1">{user?.user?.name}</h2>
                        <p className="mb-1">{user?.user?.address}</p>
                        <p className="mb-1">{user?.user?.email}</p>
                    </div>
                </div>
                <div className="w-50">
                    <div className="text-end">
                        <p className="mb-1 mt-2">{currentDate()}</p>
                    </div>
                </div>
            </div>
            <div className="w-100 px-4">
                <table className="pdf-table1">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Description</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="bg-303778 w-60px">01</td>
                            <td>
                                <h6 className="mb-1">Fund Request</h6>
                                {/* <p className="mb-0">Fund request for staff</p> */}
                            </td>
                            <td className="bg-303778 w-100px">${amount}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="d-flex w-100 px-4 py-3 invoice-header">
                <div className="w-65">
                    {/* <h3 className="pt-4">Thank You</h3> */}
                </div>
                <div className="w-35">
                    <div>
                        <table className="pdf-table2">
                            <thead>
                                <tr className="bb-rgb-237">
                                    <th>SUBTOTAL</th>
                                    <th>${amount - (amount * 0.07)}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="bb-303778">
                                    <th className="clr-303778">TAX 7%</th>
                                    <th className="clr-303778">${(amount * 0.07)?.toFixed(2)}</th>
                                </tr>
                                <tr>
                                    <th>GRAND TOTAL</th>
                                    <th>${(parseFloat(amount))?.toFixed(2)}</th>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}); 